<template>
  <div class="dwp-overflow-auto">
    <div class="dwp-flex dwp-justify-between dwp-items-center dwp-p-6">
      <ArrowLeftIcon
        data-cy="close-tab"
        @click="tab = false"
        class="dwp-text-gray-500 dwp-w-5 dwp-h-5 dwp-cursor-pointer"
      />
      <div class="dwp-leading-none dwp-text-gray-700 dwp-font-medium">
        <slot name="title" />
      </div>
      <div class="dwp-w-5 dwp-h-5"></div>
    </div>
    <slot />
  </div>
</template>

<script>
import { ArrowLeftIcon } from "vue-feather-icons";
import { sync } from "vuex-pathify";
export default {
  components: {
    ArrowLeftIcon,
  },
  computed: {
    tab: sync("ui/menu@tab"),
  },
};
</script>